<template>
  <v-tabs
    v-model="tabStore"
    background-color="base"
    class="rounded-b-lg"
    color="tertiary"
    centered
  >
    <v-tab v-for="item in tabs" :key="item.tab">
      {{ item.tab }}
    </v-tab>
    <v-tabs-items v-model="tabStore" class="d-flex justify-center base pt-4">
      <slot></slot>
    </v-tabs-items>
  </v-tabs>
</template>
<script>
/**
 * @ Registration Tabs
 * @description Componente que exibe as abas.
 * @property {Object} tabs - Lista de abas.
 */
export default {
  name: "Tabs",
  props: {
    /**
     * @property {Object} tabs - Lista de abas.
     */
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tabStore: 0,
    };
  },
};
</script>
<style></style>
